import { render, staticRenderFns } from "./BusCompanyEdit.vue?vue&type=template&id=3a368f2c&"
import script from "./BusCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./BusCompanyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports